import React, { useState, createContext, useEffect } from 'react'

const defaultState = {
	isNavMenuOpen: false,
	toggleNavMenu: () => {},
	hideNavMenu: () => {},
}

interface INavContext {
	isNavMenuOpen: boolean
	toggleNavMenu: () => void
	hideNavMenu: () => void
}

interface INavContextProviderProps {
	children: React.ReactNode
}

export const NavContext = createContext<INavContext>(defaultState)

export const NavContextProvider: React.FC<INavContextProviderProps> = ({ children }) => {
	const [isNavMenuOpen, setIsNavMenuOpen] = useState(defaultState.isNavMenuOpen)

	useEffect(() => {
		// console.log(isNavMenuOpen)
	}, [isNavMenuOpen])

	const toggleNavMenu = () => {
		setIsNavMenuOpen(!isNavMenuOpen)
	}

	const hideNavMenu = () => {
		setIsNavMenuOpen(false)
	}

	return (
		<NavContext.Provider
			value={{
				isNavMenuOpen,
				toggleNavMenu,
				hideNavMenu,
			}}
		>
			{children}
		</NavContext.Provider>
	)
}
